import { createFileRoute, useParams } from "@tanstack/react-router";
import { ProjectPage } from "../components/projects/ProjectPage";
import { ReleasesPage } from "../components/releases/ReleasesPage";

/** A project's releases (BUILD_SPEC §14.2). */
function Page() {
  const { projectKey } = useParams({ from: "/admin/p/$projectKey/releases/" });
  return (
    <ProjectPage projectKey={projectKey}>
      {(project, canManage) => <ReleasesPage project={project} canManage={canManage} />}
    </ProjectPage>
  );
}

export const Route = createFileRoute("/admin/p/$projectKey/releases/")({ component: Page });
